import { render } from "./HistoryDetailPageSubtitle.vue?vue&type=template&id=1d876d66&scoped=true"
import script from "./HistoryDetailPageSubtitle.vue?vue&type=script&lang=js"
export * from "./HistoryDetailPageSubtitle.vue?vue&type=script&lang=js"

import "./HistoryDetailPageSubtitle.vue?vue&type=style&index=0&id=1d876d66&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d876d66"]])

export default __exports__